import { Band, Eyebrow, displayFont } from "./band-helpers";
import { processSteps } from "@/lib/content-blocks-data";
import { StorefrontIcon } from "@/components/storefront-icon";

export function ProcessBand() {
  return (
    <Band className="bg-white py-12 sm:py-16" aria-label="How it works">
      <div className="text-center">
        <Eyebrow>How it works</Eyebrow>
        <h2
          className={`${displayFont.className} mt-3 text-[clamp(1.7rem,3.2vw,2.7rem)] font-bold leading-[1.1] tracking-tight storefront-text-heading`}
        >
          Three steps to a proper meal.
        </h2>
      </div>

      <div className="relative mt-12 grid gap-6 lg:grid-cols-3">
        <div className="pointer-events-none absolute left-0 right-0 top-12 hidden h-px bg-[#d6e4d2] lg:block" />

        {processSteps.map((step) => (
          <article
            key={step.number}
            className="relative rounded-[1.6rem] border storefront-border-soft bg-[#fdfefb] px-6 py-8 text-center shadow-[0_20px_48px_-28px_rgba(0,39,0,0.2)]"
          >
            <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-[#007d32] text-white shadow-[0_12px_24px_-8px_rgba(0,125,50,0.4)]">
              <StorefrontIcon
                context="feature"
                label={step.iconLabel}
                className="h-7 w-7"
              />
            </div>
            <p className="mt-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#7d957f]">
              Step {step.number}
            </p>
            <h3 className="mt-4 text-xl font-semibold tracking-tight storefront-text-heading">
              {step.title}
            </h3>
            <p className="mt-3 text-sm leading-6 storefront-text-body">
              {step.description}
            </p>
          </article>
        ))}
      </div>
    </Band>
  );
}
